import React, { ReactNode } from 'react';
import { extendClassName } from 'utils/common';
import { colors } from 'utils/constants';

interface IBoxWithDarkGreyFill {
  additionalClassName?: string;
  children: ReactNode;
  centerHorizontal?: boolean;
  centerVertical?: boolean;
  outline?: boolean;
  onClick?: () => void;
}

const BoxWithDarkGreyFill = ({
  additionalClassName,
  children,
  centerHorizontal = false,
  centerVertical = false,
  outline = false,
  onClick,
}: IBoxWithDarkGreyFill) => {
  return (
    <div
      className={extendClassName('boxWithDarkGreyFill', [
        centerHorizontal ? 'text-centered' : '',
        centerVertical ? 'flexCentered' : '',
        additionalClassName || '',
      ])}
      onClick={onClick}
    >
      {children}

      <style jsx>
        {`
          .boxWithDarkGreyFill {
            background: ${colors.primaryBrandGray};
            border-color: ${colors.primaryBrandGray};
            border-radius: 12px;
            color: white;
            box-shadow: 0 0 0 3px ${colors.primaryBrandGray};
            // outline: ${
              outline
              //   ? `3px solid ${colors.primaryBrandGray}`
              //   : 'unset'};
            }

            
        `}
      </style>
    </div>
  );
};

export default BoxWithDarkGreyFill;
